export default "/images/vendor/flag-icons/flags/1x1/es-ct.svg?9d52c0a552153cf8823845c3d9fab569";